import AbstractService, {
  InterfaceUser,
  ServiceUser,
  ModelUser
} from "./AbstractService";

/**
 * AuthService
 */
export default class UserService extends AbstractService implements InterfaceUser {
  /**
   * ServiceAuth
   */
  static service: ServiceUser;

  /**
   * constructor
   */
  constructor() {
    super();

    UserService.service = this.getApi().getServiceUser();
  }

  /**
   * creatUser
   * @param user
   */
  creatUser(user: ModelUser): Promise<ModelUser> {
    return UserService.service.creatUser(user);
  }

  /**
   * getAll
   */
  getAll(): Promise<ModelUser[]> {
    return UserService.service.getAll();
  }

  /**
   * getDatatable
   */
  getDatatable(tableParameter = {}): Promise<any> {
    return UserService.service.getDatatable(tableParameter);
  }

  /**
   * getById
   * @param id
   */
  getById(id: string): Promise<ModelUser> {
    return UserService.service.getById(id);
  }

  /**
   * updateUser
   * @param id
   * @param user
   */
  updateUser(id: string, user: ModelUser): Promise<ModelUser> {
    return UserService.service.updateUser(id, user);
  }

  /**
   * getUserImage
   * @param hashId
   */
  getUserImage(hashId: string): string {
    return UserService.service.getUserImage(hashId);
  }
}
